import { motion } from "framer-motion";

const easeOut = [0.16, 1, 0.3, 1];

// Fade-up on scroll into view.
export function Reveal({ children, delay = 0, y = 28, className = "", ...rest }) {
  return (
    <motion.div
      initial={{ opacity: 0, y }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true, margin: "-80px" }}
      transition={{ duration: 0.8, delay, ease: easeOut }}
      className={className}
      {...rest}
    >
      {children}
    </motion.div>
  );
}

// Masked line-by-line reveal for hero headings.
export function MaskLines({ lines, className = "", lineClassName = "", start = 0 }) {
  return (
    <span className={className}>
      {lines.map((line, i) => (
        <span key={i} className="line-mask">
          <motion.span
            className={`block ${lineClassName}`}
            initial={{ y: "110%" }}
            animate={{ y: "0%" }}
            transition={{ duration: 1.05, delay: start + i * 0.12, ease: easeOut }}
          >
            {line}
          </motion.span>
        </span>
      ))}
    </span>
  );
}
